// extracted by mini-css-extract-plugin
module.exports = {"imgLoader":"ImgLoader_imgLoader__npm9y","load7":"ImgLoader_load7__21Huk"};